/* Mutantur fix (Oct 2026): on desktop, clicking a top-level menu item that has a
   dropdown (e.g. "Gifts & Seasonal") opens the dropdown instead of navigating to
   the all-products page. Ctrl/Cmd/middle-click still follow the link. */
(() => {
  if (window.__mutanturMenuClick) return;
  window.__mutanturMenuClick = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = event.target instanceof Element ? event.target : null;
    const link = target ? target.closest('header-menu a[ref="menuitem"]') : null;
    if (!link) return;

    const listItem = link.closest('.menu-list__list-item');
    if (!listItem || listItem.slot) return; // leave the "More" overflow panel alone
    if (!listItem.querySelector(':scope > [ref="submenu[]"]')) return; // plain links still navigate

    event.preventDefault();

    const menu = link.closest('header-menu');
    if (menu && typeof menu.activate === 'function') {
      menu.activate({ type: 'click', target: link });
    }
  });
})();
